// extracted by mini-css-extract-plugin
export var layoutContainer = "_av-0";
export var layoutContainerNoRounding = "_av-6";
export var layoutContainerOpen = "_av-5";
export var layoutContainerResizing = "_av-1";
export var mainContent = "_av-2";
export var resizeDivider = "_av-3";
export var slidePanel = "_av-4";